export enum PageKeyword {
  treeeditor = 'support_popup.keyword.treeeditor',
  individualeditor = 'support_popup.keyword.individualeditor',
  familyeditor = 'support_popup.keyword.familyeditor',
  dashboard = 'support_popup.keyword.dashboard',
  sourceeditor = 'support_popup.keyword.sourceeditor',
  placeeditor = 'support_popup.keyword.placeeditor',
  fanchart = 'support_popup.keyword.fanchart',
  artistictree = 'support_popup.keyword.artistictree',
  descendant = 'support_popup.keyword.descendant',
  pedigree = 'support_popup.keyword.pedigree',
  timelinereport = 'support_popup.keyword.timelinereport',
  sunchart = 'support_popup.keyword.sunchart',
  mapreport = 'support_popup.keyword.mapreport',
  PersonReport = 'support_popup.keyword.PersonReport',
  familyprojectmanager = 'support_popup.keyword.familyprojectmanager'
}

